var _path, _path2, _mask, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTwitterFill = function SvgTwitterFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.077 20c7.246 0 11.438-5.626 11.438-10.965 0-.147 1.03-1.03 1.47-2.874a.441.441 0 0 0-.616-.512c-.88.404-1.773.084-2.161-.376a3.874 3.874 0 0 0-5.574-.175 4.112 4.112 0 0 0-1.14 3.86c-3.351.24-5.652-1.349-7.544-3.526-.244-.283-.697-.134-.748.24-.28 2.082-.368 7.144 4.648 10.051-.871 1.252-2.576 1.991-4.474 2.308-.42.071-.52.653-.136.841a10.923 10.923 0 0 0 4.837 1.125",
    fill: "#000"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "twitter-fill_svg__a",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 4,
    width: 18,
    height: 17
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.077 20c7.246 0 11.438-5.626 11.438-10.965 0-.147 1.03-1.03 1.47-2.874a.441.441 0 0 0-.616-.512c-.88.404-1.773.084-2.161-.376a3.874 3.874 0 0 0-5.574-.175 4.112 4.112 0 0 0-1.14 3.86c-3.351.24-5.652-1.349-7.544-3.526-.244-.283-.697-.134-.748.24-.28 2.082-.368 7.144 4.648 10.051-.871 1.252-2.576 1.991-4.474 2.308-.42.071-.52.653-.136.841a10.923 10.923 0 0 0 4.837 1.125",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#twitter-fill_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 0h24v24H0z"
  }))));
};

export default SvgTwitterFill;